import type { Selector } from "@reduxjs/toolkit";
import { createSelector } from "@reduxjs/toolkit";

import type { IRfqTransaction } from "@/shop/types/shopping/rfq";

import type { IRfqReducerState } from "./types";
import type { IShopRootState } from "../../types";

const getRfqState: Selector<IShopRootState, IRfqReducerState> = (state) => state.shopping.rfq;

export const getRfq: Selector<IShopRootState, IRfqTransaction> = createSelector(getRfqState, (state) => state.rfq);

export const getRfqIsFetching = createSelector(getRfqState, (state) => state.isFetching);

export const getRfqHasError = createSelector(getRfqState, (state) => state.hasError);

export const getRfqErrorStatusCode = createSelector(getRfqState, (state) => state.errorStatusCode);

type RfqStatus = "success" | "error";

export const getRfqStatus: Selector<IShopRootState, RfqStatus> = createSelector(getRfqState, (state) => state.rfqStatus);

export const getRfqIsSubmitting: Selector<IShopRootState, boolean> = createSelector(getRfqState, (state) => state.isSubmitting);

// show or hide rfq commissions page
export const getShowRfqCommissionsPage = createSelector(getRfqState, () => true);
